import { render } from "./Wall3View.vue?vue&type=template&id=196fb3dd&scoped=true"
const script = {}

import "./Wall3View.vue?vue&type=style&index=0&id=196fb3dd&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-196fb3dd"]])

export default __exports__